import { IHeaderParams } from 'ag-grid-community'
import React from 'react'
import { createGroupedActionRenderer } from '..'
import { initiatedNegotiationDetailsToTopLevelDetailsTransformerSelector } from 'selectors/negotiations'
import { LiveActionsCell } from 'view/routes/requests/LiveNegotiationsGrid/LiveActionsCell'
import { BackToStagingAllNegotiationsButton } from './BackToStagingAllNegotiationsButton'

interface BackToStagingAllOrGroupedActionsRendererProps extends IHeaderParams {}

export class BackToStagingAllOrGroupedActionsRenderer extends React.Component<BackToStagingAllOrGroupedActionsRendererProps> {
  render() {
    const isRowSelected = this.props.api.getSelectedRows()
    const GroupedActionRendererComponent = createGroupedActionRenderer(
      LiveActionsCell,
      initiatedNegotiationDetailsToTopLevelDetailsTransformerSelector
    )

    return isRowSelected.length > 0 ? (
      <GroupedActionRendererComponent {...this.props} />
    ) : (
      <BackToStagingAllNegotiationsButton {...this.props} />
    )
  }

  refresh = () => {
    this.forceUpdate()
    return true
  }
}
